// All God motion system: reveals [data-ag-reveal] elements as they scroll into view.
// Setting "Off", reduced-motion devices, the Theme Editor and browsers without
// IntersectionObserver all leave content fully visible.
(() => {
  const root = document.documentElement;
  const level = root.dataset.agMotion || 'subtle';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const designMode = Boolean(window.Shopify && window.Shopify.designMode);

  if (level === 'off' || reduced.matches || designMode || !('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
  );

  const observe = (scope) => {
    scope.querySelectorAll('[data-ag-reveal]:not(.is-revealed)').forEach((el) => {
      // Anything already on screen at load shows immediately, without animating.
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        el.classList.add('is-revealed');
      } else {
        observer.observe(el);
      }
    });
  };

  root.classList.add('ag-motion-ready');
  observe(document);

  reduced.addEventListener('change', (event) => {
    if (!event.matches) return;
    document.querySelectorAll('[data-ag-reveal]').forEach((el) => el.classList.add('is-revealed'));
    observer.disconnect();
  });
})();
